import { createContext, useCallback, useContext, useEffect, useState } from "react";

const KEY = "ovamx:onboarded";
const Ctx = createContext(null);

export function OnboardingProvider({ children }) {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    let done = false;
    try { done = localStorage.getItem(KEY) === "1"; } catch {}
    if (!done) setOpen(true);
  }, []);

  const finish = useCallback(() => {
    try { localStorage.setItem(KEY, "1"); } catch {}
    setOpen(false);
  }, []);

  const replay = useCallback(() => {
    try { localStorage.removeItem(KEY); } catch {}
    setOpen(true);
  }, []);

  return (
    <Ctx.Provider value={{ open, finish, replay }}>
      {children}
    </Ctx.Provider>
  );
}

export const useOnboarding = () => useContext(Ctx);
